import { render } from "./MegaAuthPending.vue?vue&type=template&id=b846d9cc&scoped=true"
import script from "./MegaAuthPending.vue?vue&type=script&lang=js"
export * from "./MegaAuthPending.vue?vue&type=script&lang=js"

import "./MegaAuthPending.vue?vue&type=style&index=0&id=b846d9cc&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../worktrees/adel01/tcd-userpage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b846d9cc"]])

export default __exports__